export default {
	"name": "san-valero",
	"basic": {
		"default": "#0B4D90",
		"font": "#fff",
		"darkMode": "#8cb7ef"
	},
	"button": {
		"default": "#0B4D90",
		"font": "#fff",
		"darkMode": "#8cb7ef"
	},
	"soft_basic": {
		"default": "#e3f4fb",
		"dark": "#e3f4fb"
	},
	"text_black": {
		"default": "#394649",
		"darkMode": "#ffffff"
	},
	"dark_black": {
		"default": "#4a4a4a",
		"darkMode": "#f3f3f3"
	},
	"medium_black": {
		"default": "#9b9b9b",
		"dark": "#f4f4f4"
	},
	"soft_black": {
		"default": "#d8d8d8",
		"dark": "#0c0c0c"
	},
	"light_black": {
		"default": "#f2f2f2",
		"dark": "#333"
	},
	"white": {
		"default": "#fff",
		"darkMode": "#222"
	},
	"hasFavicon": true,
	"logo": "/static/img/brands/logo.svg",
	"logocolor": "/static/img/brands/logo-color.svg",
	"logoLogin": "/static/img/brands/logo.svg",
	"logoencabezado": "/static/img/brands/logo.svg",
	"logodarkmode": "/static/img/brands/logo.svg",
	"logoSize": "medium",
	"background": "/static/img/brands/background.jpg",
	"emailContacto": "agenciac@svalero.com",
	"emailContactoEmpresa": "empresas@svalero.com",
	"emailProblemas": "",
	"emailInscripcion": "",
	"analitycs": "",
	"nameCentro": "la Fundación San Valero",
	"localidadesEnDominios": true,
	"footer": {
		"es": {
			"textos": [
				"© Centro San Valero 2026"
			],
			"links": {
				"Manual Empresa": "/static/docs/manual-empresas.pdf",
				"Manual Candidato": "/static/docs/manual-candidato.pdf",
				"Manual Estudiantes": "/static/docs/manual-estudiante.pdf",
				"Aviso Legal": "https://www.sanvalero.es/aviso-legal",
				"Política de Privacidad": "https://www.sanvalero.es/politica-privacidad",
				"Política de Cookies": "https://www.sanvalero.es/politica-cookies"
			}
		}
	},
	"fonts": {
		"link": "family=Lato:400,500,700",
		"principal": "'Lato', sans-serif",
		"secundaria": "'Lato', sans-serif"
	},

	"logintexts": {
		"es": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "Estudiantes",
			"empresas": "Empresas",
			"candidatos": "Candidatos Empleo",
			"estudiantesAgenciaColocacion": "Prácticas Estudiantes"
		}
	},
	//LOGIN
	"ownlogin": {
		"hasEstudiante": true,
		"hasEgresado": false,
		"textoEstudiantes": {
			"es": "Los estudiantes de San Valero disponen de usuario y contraseña propios para acceso a los servicios y sistemas del centro.<br><strong>Accede a continuación para identificarte.</strong>"
		},
		"textoEgresados": {
			"es": "Los estudiantes de San Valero disponen de usuario y contraseña propios para acceso a los servicios y sistemas del centro.<br><strong>Accede a continuación para identificarte.</strong>"
		},
		"textoCandidatos": {
			"es": "Los estudiantes de San Valero disponen de usuario y contraseña propios para acceso a los servicios y sistemas del centro.<br><strong>Accede a continuación para identificarte.</strong>"
		}
	},
	"popupDatosObligatorios": true,
	"canRecoveryPass": true,
	"hideSAML": true,
	"ownFormLogin": ['alumnos', 'antiguos'],
	"OneLoginForCandidatos": true,
	"agenciaColocacion": true,
	"canRegistroAlumno": ["candidatos"],
	infoRGDP: false,
	//CV DEL USUARIO
	"quitarCampoDiscapacidad": true,
	"otrosIntereses": false,
	//PROPUESTA DE PRACTICAS
	//"instruccionesPropuestaPracticas": "/static/img/brands/uax/instrucciones-propuesta-de-practicas.pdf",
	"showPropuestaPracticas": true,
	// "documentosPracticas": {
	// 	"url": "https://www.miotroseguro.com/"
	// },
	//REGISTRO DE LAS EMPRESAS
	"requestTipoEmpresa": true,
	"requestDireccionFullContactoEmpresa": false,
	"requestDatosFirmanteEnPropuesta": true,
	"requestDireccionContactoEmpresa": false,
	"requestTipoContacto": false,
	"registroEmpresas": {
		"convenioAplicable": true,
		"vacacionesConvenio": true,
		"horasAnuales": true,
		"sede": {
			"visible": true,
			"required": true
		},
		"dni": {
			"visible": true,
			"required": true
		},
		"logo": {
			"visible": true,
		},
		"web": {
			"visible": false,
		}
	},

	"niveles": [
		{
			id: "grado",
			active: false,
			label: {
				"es": "Grado",
				"ca": "Grau"
			}
		},
		{
			id: "postgrado",
			active: false,
			label: {
				"es": "Postgrado",
				"ca": "Postgrau"
			}
		},
		{
			id: "tituloPropio",
			active: false,
			label: {
				"es": "Título Propio",
				"ca": "Títol Propi"
			}
		}
	],

	"camposOferta": {
		"otraRemuneracion": {
			"label": {
				"es": "Otra remuneración"
			},
			"showIn": ['Empleo'],
			"showrequired": false
		},
		"ayudaEstudio": {
			"label": "Remuneración (en €)",
			"showIn": ['Practicas']
		},
		"areaFuncional": {
			"label": "Área funcional",
			"showIn": ['Practicas', 'Empleo'],
			"showrequired": false
		},
		"descripcion": {
			"label": {
				"Empleo": {
					"es": "Descripción del puesto*",
				},
				"Practicas": {
					"es": "Descripción del puesto*"
				}
			}
		},
		"experiencia": {
			"showIn": ['Empleo', 'Practicas'],
		},
		"motivosexclusion": {
			"showIn": ['Empleo', 'Practicas']
		}
	},
	"CVRequired": true, // cv marcadao por defecto en documentacion en alta oferta empleo para candidatos
	"camposPracticas": {
		"puestoTrabajo": {
			"label": "Nombre de la práctica/ puesto a desempeñar",
			"required": true
		},
		"tareasDesarrollar": {
			"label": "Descripción del puesto",
			"required": true
		},
		"datostutoruniversidad": {
			"label": "Nombre y apellidos del tutor de la Universidad",
			"required": true
		},
		"centropracticas": {
			"label": "Centro de prácticas",
			"required": false
		},
		"ayudaEstudio": {
			"label": "Remuneración",
		},
		"tutorEmpresa": {
			"dni": true,
			telefono: true,
		},
		"practicaRemunerada": {
			"label": {
				"es": "Práctica remunerada"
			},
			"showIn": ['Practicas']
		},
		"tipoPracticaCurriExtracurri": true,
		"solicitudParaCentroEducativo": true,
	},
	"hasResumen": true,
	"canDeleteOferta": false,
	"canDuplicarOferta": true,
	"canDuplicarOfertaInvertida": false,
	"canCerrarOferta": true,
	"canBorrarOferta": true,
	"academicos": {
		"calificacion": {
			"editable": true
		},
		"centro": {
			"editable": true
		},
		"nivelesEstudio": {
			"editable": true
		},
		"ramaTitulacion": {
			"editable": true
		}
	},
	"personales": {
		"camposEditables": true,
		"nombre": {
			"visible": true,
			"editable": true
		},
		"apellido1": {
			"visible": true,
			"editable": true
		},
		"apellido2": {
			"visible": true,
			"editable": true
		},
		"idPaisSegundaNacionalidad": {
			"visible": true,
			"editable": true
		},
		"tipoDocumentoIdentidad": {
			"visible": true,
			"editable": true
		},
		"documentoIdentidad": {
			"visible": true,
			"editable": true
		},
		"emailestudiante": {
			"visible": true,
			"editable": true
		},
		"imagen": {
			"visible": true,
			"editable": true
		},
		"email": {
			"visible": false,
			"editable": true,
			"required": false
		},
		"telefono": {
			"visible": false,
			"editable": true
		},
		"movil": {
			"visible": true,
			"editable": true,
			"required": true
		},
		"genero": {
			"visible": true,
			"editable": true,
			"required": true
		},
		"permisotrabajo": {
			"visible": true,
			"editable": true
		},
		"aceptaNewsletter": {
			"visible": true,
			"editable": true,
			"required": false
		},
		"fecha_nacimiento": {
			"visible": true,
			"editable": true,
			"required": true
		},
		"password": false,
		"iban": {
			"visible": false,
			"editable": false
		},
		"numeroSeguridadSocial": {
			"visible": false,
			"editable": true
		},
		"idPaisNacionalidad": {
			"visible": false,
			"editable": true,
			"required": true
		},
		"idPaisResidencia": {
			"visible": true,
			"editable": true,
			"required": true
		},
		"discapacidad": {
			"visible": true,
			"editable": true,
		},
		"direcciones": {
			"1": {
				"visible": false,
				"editable": false,
				"hide": ['tipovia', 'piso', 'numero', 'puerta'],
				"nombre": {
					"es": "Dirección actual"
				}
			},
			"2": {
				"visible": false,
				"editable": false,
				"hide": ['tipovia', 'piso', 'numero', 'puerta'],
				"nombre": {
					"es": "Dirección"
				}
			}
		},
		"direccionsimple": {
			"visible": true,
			"editable": true,
		},
		"provincia": {
			"visible": true,
			"editable": true,
		},
		"localidad": {
			"visible": true,
			"editable": true,
		},
		"cp": {
			"visible": true,
			"editable": true,
		},
		"busquedaPracticasActiva": {
			"visible": true,
			"editable": true,
		}
	},
	"experiencia": {
		"descripcion": {
			"editable": true,
			"validate": 'required'
		},
		"sector": {
			"editable": true,
			"validate": 'required'
		},
		"empresa": {
			"editable": true,
			"validate": 'required'
		},
		"provincia": {
			"editable": true,
			"validate": 'required'
		},
		"duracion": {
			"editable": true,

		},
		"enlace": {
			"editable": true,

		},
		"adjunto": {
			"editable": true,
			"validate": 'required'
		},

	},

	"profesionales": {
		"intercambio": {
			"editable": false,
			"visible": false
		},
		"retribucion": {
			"editable": false,
			"visible": false
		},
		"permisoUE": {
			"editable": false,
			"visible": false
		}
	},

	"interes": {
		"cochePropio": true,
		"carnetConducir": true,
		"busquedaActivaEmpleo": true,
		"horarioPreferenciaPracticas": true,
		"provinciaPreferenciaPracticas": true
	},
	// EMPRESA
	"ofertasEmpleo": true,
	"miEmpresa": {
		"centroTrabajo": {
			"annadir": true,
			"editar": true
		},
		"camposEditables": true,
		"canBorrarCuenta": true,
	},
	"camposOferta": {
		"denominacionCNO": true,
		"CNO": true,
		"otraRemuneracion": {
			"label": {
				"es": "Otra remuneración"
			},
			"showIn": ['Empleo'],
			"required": true
		},
		"ayudaEstudio": {
			"label": {
				"es": "Ayuda al estudio"
			},
			"showIn": ['Practicas']
		},
		"areaFuncional": {
			"label": "Área funcional",
			"showIn": ['Practicas', 'Empleo'],
			"showrequired": true
		},
		"descripcion": {
			"label": {
				"Empleo": {
					"es": "Descripción del puesto",
				},
				"Practicas": {
					"es": "Descripción del puesto"
				}
			}
		},
		modalidad: {
			"label": {
				"es": "Modalidad"
			},
			"showIn": ['Practicas', 'Empleo']
		},

	},
	"siteAlumnos": {
		"showPropuestaPracticas": true,
		"showDarDeBaja": true,
		"showMisEncuestas": true,
		"showMisCandidaturas": true,
		"showBuscarOfertas": false,
		"canBorrarCuenta": false
	},
	"siteEmpresa": {
		"showPropuestaPracticas": true,
		"showMisEncuestas": true,
		"showMisCandidaturas": true
	},
	"listadoOfertasHome": true,
	"canSubirConvenios": false,
	"canCrearConvenios": true,
	mensajeconveniogenerado: {
		titulo:
			"Su solicitud se ha recibido correctamente. La tramitaremos en el menor tiempo posible informándoles por email tanto a usted como solicitante como al firmante del mismo.",
		mensaje: "",
		to: "/documentacion"
	},
	inactiveOfertasPracticas: false,
	ocultarSedeTitulacionesOferta: true, //Activamos si no queremos que se muestre el centro de estudios en la oferta de prácticas para que se muestren directamente las titulaciones
	dualIntensiva: true, // para centros que tengan habilitada la formación dual intensiva
	convocatoriaFpDualIntensiva: {
		"preTitle": "Para la participación en DUAL RÉGIMEN INTENSIVO debe leer la información siguiente de forma previa.",
		"title": "INFORMACIÓN SOBRE FP DUAL RÉGIMEN INTENSIVO",
		"sectionTitle1": "A.- CONVOCATORIA FP DUAL RÉGIMEN  INTENSIVO",
		"sectionDescription1": 'El DECRETO 91/2024, de 5 de junio, del Gobierno de Aragón por el que se establece la Ordenación de la Formación Profesional del Grado D y del Grado E en la Comunidad Autónoma de Aragón, indica en su capítulo VI referido a la "Formación Profesional en régimen intensivo", las bases para la Autorización de Grados D o E en régimen intensivo. Para el próximo curso 2026-2027, las empresas interesadas en participar en la formación DUAL en RÉGIMEN INTENSIVO deben revisar las siguientes instrucciones antes de solicitar alumnado en DUAL Régimen Intensivo. ',
		"sectionTitle2": "B.- INFORMACIÓN PROYECTOS DUAL RÉGIMEN INTENSIVO",
		"sectionDescription2": '<ul><li><strong>Presentación </strong>de FP DUAL RÉGIMEN INTENSIVO desarrollado en Centro San Valero:  <a href="/static/docs/presentacion_Dual_Intensiva_Empresas_2026_2027DEF.pdf" target="_blank" rel="noopener noreferrer">Presentación DUAL INTENSIVA Empresas 2026-2027 DEF</a></li><li>Documento informativo actualizado al<strong> curso 2026-27</strong> sobre las diferencias entre el Contrato de Formación en Alternancia y la Beca de Formación a la hora de formalizar el proyecto de DUAL en RÉGIMEN INTENSIVO:<a href="/static/docs/informacion_Dual_Intensiva_Empresas_2026_2027DEF.pdf" target="_blank" rel="noopener noreferrer"> Información DUAL INTENSIVA Empresas 2026-2027 DEF</a></li><li>Vídeo sobre testimonios de empresas y alumnado cursos anteriores:<a href="https://www.youtube.com/watch?v=D1_RJ6Qf4Bo" target="_blank" rel="noopener noreferrer">  https://www.youtube.com/watch?v=D1_RJ6Qf4Bo</a></li></ul>',
		"sectionTitle3": "Los ciclos que ofrecemos desde Centro San Valero <br>en modalidad DUAL RÉGIMEN INTENSIVO son: ",
		"keys": [
			"Grado Medio Electromecánica de Vehículos Automóviles", "Grado Superior Automatización y Robótica Industrial ",
			"Grado Superior Mecatrónica Industrial ", "Grado Superior Mantenimiento Electrónico ", "Grado Superior Construcciones Metálicas ", "Grado Superior Transporte y Logística ", "Grado Superior Desarrollo de Aplicaciones Web ", "Grado Superior Desarrollo Aplicaciones Multiplataforma ", "Grado Superior Administración y Finanzas ", "Grado Superior Automoción ", "Grado Superior Programación de la Producción en Fabricación Mecánica "
		],
		"sectionTitle4": "C.-DOCUMENTACIÓN DE SU EMPRESA PARA PODER PARTICIPAR EN DUAL RÉGIMEN INTENSIVO",
		"sectionDescription4": '<ul><li>Deberá cumplimentar su oferta de prácticas desde el portal de empresas,<strong> indicando Modalidad de Dual, Dual Intensiva.</strong></li><li>Rellenar ANEXO XIV Solicitud de Participación<a href="/static/docs/documentacion-dual-intensiva.pdf" target="_blank" download rel="noopener noreferrer"> (descargar)</a> que deberá adjuntar a la hora de crear la oferta o posteriormente cuando el gestor se lo solicite (un Anexo diferente por Ciclo Formativo que se quiera acoger alumnado). </li><li>En su <a href="/mi-empresa" target="_blank" rel="noopener noreferrer">perfil de empresa</a> deberá incluir el LOGOTIPO de su empresa si no está ya incluido (Imprescindible). </li></ul>',
		"sectionDescription5": 'Para cualquier duda pueden llamar por teléfono al centro al<strong> 976 466 599</strong> o remitir mail a <a href="mailto:empresas@svalero.com">empresas@svalero.com</a> ',
	},

}



// WEBPACK FOOTER //
// ./src/brands/brands.js